import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../../../components/atoms/SectionTitle';
import Button from '../../../components/atoms/Button';
import InfoText from '../../../components/atoms/InfoText';

interface EditSubscriptionPlanHeaderProps {
  formId: string;
  isLoading?: boolean;
  disabled?: boolean;
}

export default function EditSubscriptionPlanHeader({
  formId,
  isLoading = false,
  disabled = false,
}: EditSubscriptionPlanHeaderProps) {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4"
      data-testid="edit-subscription-plan-header"
    >
      <div className="flex flex-col gap-1" data-testid="edit-plan-title-breadcrumb-wrapper">
        <SectionTitle text={t('home.edit-plan-modal-title')} />
        <div
          className="flex items-center gap-2 text-sm text-light-text-placeholder dark:text-dark-text-placeholder"
          data-testid="edit-plan-breadcrumbs"
        >
          <Link to="/" className="hover:text-light-text-primary dark:hover:text-dark-text-primary transition-colors">
            {t('home.dashboard')}
          </Link>
          <InfoText text="/" className="!text-light-text-placeholder dark:!text-dark-text-placeholder" />
          <Link
            to="/subscriptions-plans"
            className="hover:text-light-text-primary dark:hover:text-dark-text-primary transition-colors"
          >
            {t('home.plans-subscribe')}
          </Link>
          <InfoText text="/" className="!text-light-text-placeholder dark:!text-dark-text-placeholder" />
          <InfoText
            text={t('home.edit-plan-modal-title')}
            className="!text-light-text-primary dark:!text-dark-text-primary !font-medium"
          />
        </div>
      </div>

      <Button
        variant="dark"
        type="submit"
        form={formId}
        loading={isLoading}
        disabled={isLoading || disabled}
        className="rounded-xl px-6 py-2.5 !font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
        data-testid="edit-plan-save-and-exit-btn"
      >
        {t('home.save-and-exit')}
      </Button>
    </div>
  );
}
